import { cloneDeep, orderBy } from 'lodash';
import { IFilterType } from '../../../../../core/types/ProfileTypes';
import { IOrderType, OrderDirection } from '../../../../../core/types/OrderType';
import { AxiosPromise } from 'axios';
import BasePaginateService from '../../../../../core/services/BasePaginateService';
import qs from 'qs';
import {handleUrlPost} from '../utils/serviceUtils';

const ALL_DROPOFF_URL: string = 'account/basicList/dropOff/v2';
const DROPOFF_URL: string = 'maintenance/dropOff';
const VALIDATE_DROPOFF_NUMBER_NAME: string = 'account/validatePickUpNameNumber';

export class DropOffService extends BasePaginateService {
  constructor() {
    super('');
  }

  public getPaginateAll(
    page: number = 1,
    size: number = 10,
    orders: IOrderType[],
    filters: IFilterType[],
    search: string,
    url: string = '',
    other?: any
  ): AxiosPromise<any[]> {
    const params = {
      search,
      filters,
      pageable: {
        page,
        size,
        orders
      },
      ...other
    };
    return this.httpAxios
      .post(ALL_DROPOFF_URL, JSON.stringify(params), {
        params: { data: JSON.stringify(params) },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'brackets' });
        }
      })
      .then((response: any) => response)
      .catch(err => {
        throw err;
      });
  }

  public getItemTanks = (pickUpId: number, params: any) => {
    return this.httpAxios
      .get(`${DROPOFF_URL}/tank/${pickUpId}`, { params })
      .then(response => response)
      .catch(err => {
        throw err;
      });
  };

  public create(item: any, loadId?: number): AxiosPromise<any> {
    const url = handleUrlPost(DROPOFF_URL, item.load?.id);
    return this.httpAxios
      .post(url, item)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }

  public update(item: any, loadId?: number): AxiosPromise<any> {
    const url = handleUrlPost(DROPOFF_URL, loadId)
    return this.httpAxios
      .post(url, item)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }

  public getAll(params: any): AxiosPromise<any[]> {
    const { filterCriteria } = params;
    const filterCriteriaEncoded = JSON.stringify(filterCriteria);
    return this.httpAxios
      .post(ALL_DROPOFF_URL, filterCriteriaEncoded)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }

  public getById(id: string | number): AxiosPromise<any[]> {
    return this.httpAxios
      .get(`${DROPOFF_URL}/${id}?isExcludeScenarios=true`)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }

  public validateNameAndNumber(item: any, accountId: number, commodity: number, layoutId: number): AxiosPromise<any[]> {
    return this.httpAxios
      .post(`${VALIDATE_DROPOFF_NUMBER_NAME}/${accountId}/${commodity}/${layoutId}`, item)
      .then(response => response)
      .catch(err => {
        throw err;
      });
  }

  getFilteredResponse = (response: any, params: any) => {
    const { filters, orders } = params;
    const resultResponse = cloneDeep(response);
    if (filters.length > 0) {
      filters.map((filter: IFilterType) => {
        if (filter.field === 'commodity' && filter.value && filter.value.length > 0) {
          resultResponse.data = resultResponse.data.filter(
            (item: any) =>
              item.commodityList &&
              item.commodityList.some((id: number) => filter.value.some((value: any) => id === value))
          );
        } else if (filter.field === 'terminal' && filter.value && filter.value.length > 0) {
          resultResponse.data = resultResponse.data.filter((item: any) =>
            filter.value.some((value: any) => item.terminal.id === value)
          );
        } else if (filter.field === 'active') {
          resultResponse.data = resultResponse.data.filter((item: any) => item.isActive === filter.value);
        } else if (filter.field === 'dropOff' && filter.value && filter.value.length > 0) {
          resultResponse.data = resultResponse.data.filter((item: any) =>
            filter.value.some((value: any) => item.id === value)
          );
        } else if (filter.field === 'contractor' && filter.value && filter.value.length > 0) {
          resultResponse.data = resultResponse.data.filter((item: any) =>
            filter.value.some((value: any) => item.contractor && item.contractor.id === value)
          );
        }
      });
      resultResponse.data = resultResponse.data.map((item: any) => ({
        ...item,
        name: `${item.contact.lastName}${item.contact.firstName && item.contact.lastName && ', '}${
          item.contact.firstName
        }`,
        address: this.getAddress(item)
      }));
    }

    if (orders && orders.length > 0) {
      const directions: OrderDirection[] = [];
      const properties: string[] = [];
      orders.map((order: IOrderType) => {
        properties.push(order.property);
        directions.push(order.sortOperation);
      });

      resultResponse.data = orderBy(resultResponse.data, properties, directions);
    }

    return resultResponse;
  };

  getAddress(element: any) {
    if (element && element.contact) {
      const contact = element.contact;
      return `${contact.streetLine1 || ''} ${contact.streetLine2 || ''} ${contact.streetLine3 || ''} ${
        contact.city ? `${contact.city}` : ''
      }${contact.county ? `, ${contact.county}` : ''}${contact.state ? `, ${contact.state}` : ''}${
        contact.zip5 ? `, ${contact.zip5}` : ''
      }${contact.zip4 ? `- ${contact.zip4}` : ''}`;
    }
    return '';
  }
}

const dropOffService = new DropOffService();

export default dropOffService;
